<template>
  <div class="customer-list">
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-white control-box" style="padding: 20px">
          <div class="left">
            <div class="select-box">
              <el-input
                v-model="search.customerName"
                :placeholder="$lange == 'en' ? 'Customer name' : '客户名称'"
                size="mini"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="select-box">
              <el-input
                size="mini"
                style="width: 200px"
                v-model="search.customerNo"
                :placeholder="$lange == 'en' ? 'Customer ID' : '客户ID'"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="select-box">
              <el-button type="primary" size="mini" @click="doSearch">{{
                $lange == "en" ? "Search" : "搜索"
              }}</el-button>
            </div>
            <div class="select-box">
              <el-button type="primary" size="mini" @click="exportData">{{
                $lange == "en" ? "Export Customer" : "导出客户"
              }}</el-button>
            </div>
            <div class="select-box">
              <el-button
                type="primary"
                size="mini"
                @click="goPage('/admin/customer/create')"
                >{{
                  $lange == "en" ? "Create Customer" : "创建客户"
                }}</el-button
              >
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <cc-table
      :config="tableConfig"
      :params="search2"
      :refesh-params="refeshTable"
    ></cc-table>
  </div>
</template>

<script>
export default {
  name: "CustomerList",
  data() {
    return {
      search: {
        customerName: "",
        customerNo: "",
      },
      search2: {
        customerName: "",
        customerNo: "",
      },
      value: "",
      refeshTable: -1,
      tableConfig: {
        api: "admin/fsb/customer/query",
        pageSize: 10,
        showPager: true,
        columns: [
          {
            prop: "customerNo",
            lable: this.$lange == "en" ? "Customer ID" : "客户ID",
          },
          {
            prop: "customerName",
            lable: this.$lange == "en" ? "Customer Name" : "客户名称",
          },
          {
            prop: "customerAddress",
            lable: this.$lange == "en" ? "Customer Address" : "客户地址",
          },
          {
            prop: "creditLevel",
            lable: this.$lange == "en" ? "Credit Level" : "信用等级",
          },
          {
            prop: "discount",
            lable: this.$lange == "en" ? "Discount" : "配件折扣",
            render: (row) => {
              return row.discount / 10;
            },
          },
          {
            prop: "customerManager",
            lable: this.$lange == "en" ? "Customer Manager" : "客户经理",
          },
          {
            prop: "annualSatisfaction",
            lable: this.$lange == "en" ? "Customer Satisfaction" : "年度满意度",
          },
          {
            prop: "createTime",
            lable: this.$lange == "en" ? "Create Time" : "创建时间",
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "View Detail" : "查看",
            click: (row) => {
              this.$router.push({
                path: "/admin/customer/description",
                query: {
                  customerId: row.id,
                },
              });
            },
          },
          {
            name: this.$lange == "en" ? "Delete" : "刪除",
            click: (row) => {
              this.delete(row);
            },
          },
        ],
      },
    };
  },
  methods: {
    doSearch() {
      this.search2 = { ...this.search };
    },
    exportData() {
      window.open(
        `${this.$apis.config.server}admin/fsb/customer/customerExport?customerName=${this.search.customerName}&customerNo=${this.search.customerNo}`
      );
    },
    goPage(path) {
      this.$router.push({
        path: path,
      });
    },
    delete(e) {
      this.$confirm("此操作将永久删除该产品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            id: e.id,
          };
          this.ccRequest
            .do("admin/fsb/customer/delete", data, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "刪除成功",
              });
              this.refeshTable = new Date().getTime();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.customer-list {
  height: 100%;
  display: flex;
  flex-direction: column;

  .control-box {
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    .select-box {
      display: inline-block;

      &:not(:first-child) {
        margin-left: 20px;
      }
    }
  }
}
</style>
